import ModelGroup from './ModelGroup';
import modelsMap from '@/scripts/stage/modelsMap';

class PolaroidGroup extends ModelGroup {
  constructor() {
    super('polaroid');
  }

  async init(callback = () => {}) {
    const baseClass = modelsMap.get('polaroid');

    await baseClass.load(callback);

    super.model = baseClass.model;
  }
}

export default new PolaroidGroup();
